import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import './App.css';

import Home from "./pages/Home";
import Contact from "./pages/Contact";

import CommercialIndustrial from "./pages/CommercialIndustrial";
import Education from "./pages/Education";
import Hospitality from "./pages/Hospitality";
import SmallBusiness from "./pages/SmallBusiness";
import NonProfit from "./pages/NonProfit";
import NotFound from './pages/NotFound';
import PrivacyPolicy from './pages/PrivacyPolicy';

import Nav from './components/Nav';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Nav />
      <Switch>
        <Route exact path="/">
          <Home />
        </Route>
        <Route exact path="/contact">
          <Contact />
        </Route>
        <Route exact path="/commercial-industrial">
          <CommercialIndustrial />
        </Route>
        <Route exact path="/education">
          <Education />
        </Route>
        <Route exact path="/hospitality">
          <Hospitality />
        </Route>
        <Route exact path="/non-profit">
          <NonProfit />
        </Route>
        <Route exact path="/small-business">
          <SmallBusiness />
        </Route>
        <Route exact path="/privacy-policy">
          <PrivacyPolicy />
        </Route>
        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
      <Footer />
    </Router>
  );
}

export default App;
